import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { ConfirmationService, MessageService } from 'primeng/api';

import { routes } from './app.routes';
import { mockApiInterceptor } from './mocks/mock-api.interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { ErrorHandlerService } from './services/error-handler/error-handler.service';
import TransfloTheme from '../theme/transflo-theme';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, mockApiInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: TransfloTheme,
        options: {
          darkModeSelector: '.p-dark',
          cssLayer: false,
        },
      },
    }),
    ConfirmationService,
    MessageService,
    { provide: ErrorHandler, useClass: ErrorHandlerService },
  ],
};
